import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { translate } from '../../locales';
import './style.css';

const SitePage: React.FC = () => {
  const { language } = useLanguage();
  const t = (key: any) => translate(key, language as 'en' | 'ua');

  return (
    <div className="site-page">
      <h1>{t('pages.site.title')}</h1>
      <p>{t('pages.site.description')}</p>
      {/* TODO: Implement site settings */}
    </div>
  );
};

export default SitePage;
